import "./slider";
import modals from './modules/modals';
import tabs from './modules/tabs';
import forms from './modules/forms';
import changeModalState from "./modules/changeModalState";
import timer from "./modules/timer";
import images from "./modules/images"
window.addEventListener('DOMContentLoaded', () => {
    modals();

    tabs('.glazing_slider ', '.glazing_block', '.glazing_content', 'active');
    tabs('.decoration_slider', '.no_click', '.decoration_content > div > div',
        'after_click');
    tabs('.balcon_icons', '.balcon_icons_img', '.big_img > img', 'do_image_more',
        'inline-block');

    let modalState = {};
    changeModalState(modalState);

    forms(modalState);

    const deadLine = '2023-03-24';
    timer(deadLine, ".timer1")

    images();
});